import api from '../services/api';

export const listarProjetos = async () => {
    return api.get('/projetos');
};

export const obterProjeto = async (id) => {
    return api.get(`/projetos/${id}`);
};

export const criarProjeto = async (formData) => {
    return api.post('/projetos', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

export const atualizarProjeto = async (id, projeto) => {
    return api.put(`/projetos/${id}`, projeto);
};

export const excluirProjeto = async (id) => {
    return api.delete(`/projetos/${id}`);
};

export const aprovarProjeto = async (id, { observacoes, emitirCredencial, numeroCredencial }) => {
  return api.post(`/projetos/${id}/aprovar`, {
    observacoes,
    emitirCredencial,
    numeroCredencial
  });
};

// ===== CORRIGIDO: FUNÇÃO DE SIMILARIDADE PADRONIZADA =====
export const obterSimilaridadeProjeto = async (id) => {
  try {
    console.log(`[DEBUG] Buscando similaridade para projeto ${id}...`);
    
    const response = await api.get(`/projetos/${id}/similaridade`);
    console.log('[DEBUG] Resposta bruta da API:', response.data);
    
    // ===== EXTRAÇÃO DEFENSIVA COM VALORES PADRÃO =====
    const dadosBrutos = response.data || {};
    
    // Função auxiliar para acessar propriedades aninhadas com segurança
    const safeGet = (obj, path, defaultValue = null) => {
      try {
        const keys = path.split('.');
        let result = obj;
        for (const key of keys) {
          result = result?.[key];
        }
        return result !== undefined && result !== null ? result : defaultValue;
      } catch {
        return defaultValue;
      }
    };

    // ===== EXTRAIR DADOS COM VALORES PADRÃO =====
    const similaresData = dadosBrutos.similares || [];
    const antiPlagioData = dadosBrutos.antiPlagio || {
      sistemaHibrido: false,
      totais: { total: 0, monografias: 0, arquivos_digitais: 0, projetos: 0, fontes_externas: 0 },
      threshold: 0.3
    };
    const iaDetectionData = dadosBrutos.iaDetection || {
      disponivel: false,
      score: 0,
      classificacao: 'Sem dados',
      recomendacao: 'Sistema não disponível',
      detalhes: {
        confianca: 0,
        analises_executadas: [],
        timestamp: new Date().toISOString()
      }
    };

    // ===== PROCESSAR DADOS DE SIMILARIDADE =====
    const similares = Array.isArray(similaresData) ? similaresData.map(item => ({
      // Identificação
      id: item.id || `projeto_${item.projetoId || 'unknown'}`,
      tipo: item.tipo || 'projeto',
      
      // Métricas de similaridade (garantir números válidos)
      score: Math.round(safeGet(item, 'score', 0)),
      similaridade: safeGet(item, 'similaridadeDireta', 0),
      similaridadeDireta: safeGet(item, 'similaridadeDireta', 0),
      jaroWinkler: safeGet(item, 'jaroWinkler', 0),
      
      // Arrays com verificação de tipo
      termosComuns: Array.isArray(item.termosComuns) ? item.termosComuns : [],
      trechosSimilares: Array.isArray(item.trechosSimilares) ? item.trechosSimilares : [],
      
      // Informações do documento original
      documentoOriginal: {
        titulo: safeGet(item, 'documentoOriginal.titulo', 'Sem título'),
        problemaPesquisa: safeGet(item, 'documentoOriginal.problemaPesquisa', 'Sem descrição'),
        estudante: safeGet(item, 'documentoOriginal.estudante', 'Desconhecido'),
        dataSubmissao: safeGet(item, 'documentoOriginal.dataSubmissao', null),
        tipo: safeGet(item, 'documentoOriginal.tipo', 'Projeto de Pesquisa')
      }
    })) : [];

    // ===== PROCESSAR DADOS DE ANTI-PLÁGIO =====
    const antiPlagio = {
      sistemaHibrido: Boolean(antiPlagioData.sistemaHibrido),
      totais: {
        total: safeGet(antiPlagioData, 'totais.total', 0),
        monografias: safeGet(antiPlagioData, 'totais.monografias', 0),
        arquivos_digitais: safeGet(antiPlagioData, 'totais.arquivos_digitais', 0),
        projetos: safeGet(antiPlagioData, 'totais.projetos', 0), // Específico para projetos
        fontes_externas: safeGet(antiPlagioData, 'totais.fontes_externas', 0)
      },
      threshold: safeGet(antiPlagioData, 'threshold', 0.3)
    };

    // ===== PROCESSAR DADOS DE IA =====
    const iaDetection = {
      disponivel: Boolean(iaDetectionData.disponivel),
      score: Math.round(safeGet(iaDetectionData, 'score', 0)),
      classificacao: safeGet(iaDetectionData, 'classificacao', 'Sem dados'),
      recomendacao: safeGet(iaDetectionData, 'recomendacao', 'Sistema não disponível'),
      detalhes: {
        confianca: Math.round(safeGet(iaDetectionData, 'detalhes.confianca', 0)),
        analises_executadas: Array.isArray(iaDetectionData.detalhes?.analises_executadas) 
          ? iaDetectionData.detalhes.analises_executadas 
          : ['estatistico'],
        timestamp: safeGet(iaDetectionData, 'detalhes.timestamp', new Date().toISOString()),
        tempo_analise_ms: safeGet(iaDetectionData, 'detalhes.tempo_analise_ms', 0),
        indicadores_principais: Array.isArray(iaDetectionData.detalhes?.indicadores_principais) 
          ? iaDetectionData.detalhes.indicadores_principais 
          : []
      }
    };

    // ===== RESPOSTA FINAL ESTRUTURADA =====
    const respostaFinal = {
      similares,
      antiPlagio,
      iaDetection,
      metadata: {
        total_comparacoes: similares.length,
        timestamp_consulta: new Date().toISOString(),
        sistema_hibrido_usado: antiPlagio.sistemaHibrido,
        deteccao_ia_disponivel: iaDetection.disponivel
      }
    };
    
    console.log('[DEBUG] Dados processados para o frontend:', respostaFinal);
    return respostaFinal;
    
  } catch (error) {
    console.error('[ERROR] Erro ao obter similaridade do projeto:', error);
    
    // ===== RETORNO SEGURO EM CASO DE ERRO =====
    return {
      similares: [],
      antiPlagio: {
        sistemaHibrido: false,
        totais: { total: 0, monografias: 0, arquivos_digitais: 0, projetos: 0, fontes_externas: 0 },
        threshold: 0.3
      },
      iaDetection: {
        disponivel: false,
        score: 0,
        classificacao: 'Erro na análise',
        recomendacao: 'Não foi possível executar a análise',
        detalhes: {
          confianca: 0,
          analises_executadas: [],
          timestamp: new Date().toISOString()
        }
      },
      metadata: {
        erro: error.message,
        timestamp_consulta: new Date().toISOString()
      }
    };
  }
};

// ===== NOVA FUNÇÃO: ANÁLISE ESPECÍFICA DE IA =====
export const analisarIAProjeto = async (id) => {
  try {
    console.log(`[IA] Solicitando análise de IA para projeto ${id}...`);
    
    const response = await api.post(`/projetos/${id}/analisar-ia`);
    console.log('[IA] Resposta da análise:', response.data);
    
    return response.data;
    
  } catch (error) {
    console.error('[IA] Erro na análise de IA:', error);
    throw error;
  }
};

export const encaminharProjetoParaRevisor = async (idProjeto, revisorId) => {
    return api.post('/projetos/encaminhar-revisor', { projetoId: idProjeto, revisorId });
};

export const registrarParecerRevisor = async ({ projetoId, parecer, recomendacao }) => {
    return api.post('/projetos/registrar-parecer', { projetoId, parecer, recomendacao });
};

export const gerarCredencialPDF = async (id) => {
    try {
        const response = await api.get(`/projetos/${id}/credencial-pdf`);
        return response.data;
    } catch (error) {
        console.error('Erro ao gerar credencial PDF:', error);
        throw error;
    }
};